import { useContext } from "react"
import MainOurPress from "src/components/Main/MainOurPress"
import MainOurService from "src/components/Main/MainOurService"
import MainPreface from "src/components/Main/MainPreface"
import MainTeamIntro from "src/components/Main/MainTeamIntro"
import { LocaleContext } from "src/contexts/contextapi"
import styles from './MainContainer.module.scss'

export default function MainContainer() {
  const { locale } = useContext(LocaleContext)
  return(
    <div className={ styles.MainContainer }>
      <MainPreface />
      <MainOurService />
      <MainOurPress />
      <MainTeamIntro />
    </div>
  )
}
